import { useState } from 'react';
import type { SceneHotspot } from './types';
import { HotspotButton } from './Hotspot';

interface SceneStageProps {
  backgroundImage: string;
  hotspots: SceneHotspot[];
  visitedIds: string[];
  onHotspotClick: (hotspot: SceneHotspot) => void;
}

export function SceneStage({ backgroundImage, hotspots, visitedIds, onHotspotClick }: SceneStageProps) {
  const [activeId, setActiveId] = useState<string | null>(null);

  function handleClick(hotspot: SceneHotspot) {
    setActiveId(prev => (prev === hotspot.id ? null : hotspot.id));
    onHotspotClick(hotspot);
  }

  return (
    <div className="escape-scene">
      <img
        src={backgroundImage}
        alt="Room scene"
        className="escape-scene__bg"
        draggable={false}
      />
      {hotspots.map(hotspot => (
        <HotspotButton
          key={hotspot.id}
          hotspot={hotspot}
          isActive={activeId === hotspot.id}
          isVisited={visitedIds.includes(hotspot.id)}
          onClick={() => handleClick(hotspot)}
        />
      ))}
      {hotspots.length === 0 && (
        <div className="escape-scene__overlay-hint">
          <i className="fa-solid fa-eye-slash" aria-hidden="true" />
          <span>Examine the puzzles in the panel →</span>
        </div>
      )}
    </div>
  );
}
